import { Button, Modal, Paper, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useDeleteSection } from "../../../../../../hooks/useDeleteSection";

const ModalDeleteSection = ({ open, close, section, token, refresh }) => {
  const { deleteSection, loading } = useDeleteSection(token);
  const handleSave = async () => {
    const success = await deleteSection(section?.ID_SECCION, 0);
    if (success) {
      close();
      refresh();
    }
  };
  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "70%",
          outline: "none",
        }}
      >
        <Typography variant="h6">
          ¿Estás seguro de que deseas eliminar esta sección?
        </Typography>
        <Typography variant="subtitle1" style={{ margin: "10px 0" }}>
          Esta acción no se puede deshacer.
        </Typography>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button variant="contained" onClick={close} color="error">
            Cancelar
          </Button>
          <LoadingButton
            variant="contained"
            color="primary"
            style={{ marginLeft: "20px" }}
            onClick={handleSave}
            loading={loading}
            disabled={loading}
          >
            Confirmar
          </LoadingButton>
        </div>
      </Paper>
    </Modal>
  );
};

export default ModalDeleteSection;
